<template>
  <div>
    <DashboardTemplate>
      <DepartmentNav
       v-bind:nav="{
          dashboard:true,
          smartReport:false,
        }"
       />
      <AdminAndStaffDashboard/>
    </DashboardTemplate>
  </div>
</template>
<script>
// @ is an alias to /src
import DashboardTemplate from "@/template/DashboardTemplate.vue";
import DepartmentNav from "@/components/DepartmentNav.vue";
import AdminAndStaffDashboard from "@/components/AdminAndStaffDashboard.vue";
import { mapGetters } from "vuex";

export default {
  name: "dashboard",
  components: {
    DashboardTemplate,
    DepartmentNav,
    AdminAndStaffDashboard,
  },
  created(){
     // console.log(this.getRule)
  },
  computed: {
    getRule() {
      return this.$store.getters.getRule;
    }
  }
};
</script>
